(() => {
  const initialize = (section) => {
    if (
      !(section instanceof HTMLElement) ||
      section.dataset.mrRecommendationsInitialized === 'true'
    ) {
      return;
    }

    section.dataset.mrRecommendationsInitialized = 'true';

    section.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-mr-recommendation-add]');

      if (!button || button.disabled) return;

      const originalText = button.textContent;
      const shopRoot = window.Shopify?.routes?.root || '/';

      button.disabled = true;
      button.textContent = 'ADDING…';

      try {
        const response = await fetch(`${shopRoot}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: Number(button.dataset.variantId),
                quantity: 1
              }
            ]
          })
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.description || data.message || 'Unable to add product.');
        }

        document.dispatchEvent(
          new CustomEvent('mr:cart-updated', {
            detail: {
              source: 'product-recommendations',
              item: data
            }
          })
        );
      } catch (error) {
        console.error(error);
        button.textContent = 'TRY AGAIN';
        window.setTimeout(() => {
          button.textContent = originalText;
        }, 1800);
      } finally {
        button.disabled = false;
      }
    });
  };

  const initializeAll = () => {
    document
      .querySelectorAll('[data-mr-product-recommendations]')
      .forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', initializeAll);
})();
